import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import clsx from 'clsx';
import { Marker } from '../../../../../../components';
import { FEMapPlaceholder } from 'ui-kit/components';

export type MapProps = {
  restaurantPosition: {
    lat: number;
    lng: number;
  };
  className: string;
};

const Map = ({ className, restaurantPosition }: MapProps) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_TOKEN ?? '',
    language: 'ru',
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName={clsx(className)}
      center={restaurantPosition}
      zoom={12}
      options={{
        disableDefaultUI: true,
      }}
    >
      <Marker position={restaurantPosition} />
    </GoogleMap>
  ) : (
    <>
      <FEMapPlaceholder className={className} />
    </>
  );
};

export default Map;
